import URLS from "@api/constants/urls";
import {
  handleGlobalDeleteRequest,
  handleGlobalPostRequest,
  handleGlobalPatchRequest,
} from "@api/functions/changeRequests";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";
import { URLSearchParamsInit } from "react-router-dom";
import {
  IConsentResponseSchema,
  IConsentSubmitSchema,
} from "./consentAPI.types";
import { IGlobalMetaSchema } from "@api/types/globalService.types";

const getAllConsentAPI = ({
  searchParams,
  signal,
}: {
  searchParams?: URLSearchParamsInit;
  signal?: AbortSignal;
}): Promise<{ data: IConsentResponseSchema[]; meta: IGlobalMetaSchema }> =>
  handleGlobalGetRequestQuery({ url: URLS.CONSENT, searchParams, signal });

const getSingleConsentAPI = (
  id: string
): Promise<{ data: IConsentResponseSchema }> =>
  handleGlobalGetRequestQuery({
    url: `${URLS.CONSENT }/${id}`,
  });

const createConsentAPI = (
  data: IConsentSubmitSchema
): Promise<{ data: IConsentResponseSchema }> =>
  handleGlobalPostRequest({ url: URLS.CONSENT, data });

const updateConsentAPI = (
  data: IConsentSubmitSchema
): Promise<{ data: IConsentResponseSchema }> =>
  handleGlobalPatchRequest({ url: `${URLS.CONSENT }/${data.id}`, data });

const deleteConsentAPI = (id: number) =>
  handleGlobalDeleteRequest({ url: `${URLS.CONSENT }/${id}` });

export {
  getAllConsentAPI,
  getSingleConsentAPI,
  createConsentAPI,
  updateConsentAPI,
  deleteConsentAPI,
};